import { useSelector } from 'react-redux';
import React from 'react';
import { selectTranslation } from 'store/translationSelector';

export function useTranslation() {
  const translation = useSelector(selectTranslation);
  // { translate, translateTooltip, translateDropdown, translateNamespace, lang }

  function replaceString(template, replace = {}) {
    let result = template;
    // Simple replacement logic
    Object.entries(replace).forEach(([k, v]) => {
      const pattern = new RegExp(`\\{${k}\\}`, 'g');
      result = result.replace(pattern, v);
    });

    return result;
  }
  const isInternalTenant = useSelector((state) => state.user.tenant.is_internal);
  const debugTranslation = useSelector((state) => state.user.debug_translation);
  const appEnv = (process.env.REACT_APP_ENV || '').trim().toLowerCase();
  const isExternal = (appEnv !== 'local' && !isInternalTenant);
  const isDev = (appEnv === 'dev');

  const editable = React.useCallback(
    (key, text, replace = {}) => {
      let finalText = text;
      let className = '';
      if (finalText?.missing) {
        finalText = text.result;
        className = 'missing-translation';
      }
      const hasBreakline = finalText?.includes('\n');
      const cls = !isExternal
        ? `editable-translation ${debugTranslation ? 'enabled' : ''}`
        : '';
      return (
        <span className={`${cls} ${className}`} data-key={key}>
          {hasBreakline
            ? finalText.split('\n').map((t, i) => (
              <span key={i}>
                {i > 0 && <br />}
                {replaceString(t, replace)}
              </span>
            ))
            : replaceString(finalText, replace)}
        </span>
      );
    },
    [isExternal, debugTranslation]
  );

  const editableString = React.useCallback(
    (key, text, replace = {}) => {
      let finalText = text;
      let className = '';
      if (finalText?.missing) {
        finalText = text.result;
        className = 'missing-translation';
      }
      if (isExternal) {
        return replaceString(finalText, replace);
      }
      const cls = `editable-translation ${debugTranslation ? 'enabled' : ''}`;
      return `<span class="${cls} ${className}" data-key="${key}">${replaceString(finalText, replace)}</span>`;
    },
    [isExternal, debugTranslation]
  );

  const editableTranslate = (key, alt = null, replace = {}) =>
    editable(key, translation.translate(key, alt, replace, !isExternal && isDev), replace);
  const editableTranslateTooltip = (key, alt = null, replace = {}) =>
    editable(`${key}`, translation.translateTooltip(key, alt, replace, !isExternal && isDev), replace);
  const editableTranslateString = (key, alt = null, replace = {}) =>
    editableString(key, translation.translate(key, alt, replace, !isExternal && isDev), replace);

  return {
    ...translation,
    editableTranslate,
    editableTranslateTooltip,
    editableTranslateString,
  };
}
